const ChargePointExpandOptions = {
    OcppConfig: 'ocppConfig',
    AdditionalInfo: 'additionalInfo',
    WifiSignal: 'wifisignal',
    PartnerInfo: 'partnerInfo',
    TopChargingLimitation: 'topChargingLimitation',
}

export default ChargePointExpandOptions
